import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg width="16px" height="25px" viewBox="0 0 16 25" version="1.1">
        <title>align-center-horizontal</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-398.000000, -71.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-8"
                        transform="translate(371.000000, 11.500000)"
                    >
                        <g
                            id="align-center-horizontal"
                            transform="translate(27.167522, 0.000000)"
                        >
                            <path
                                d="M7.86206897,20.2758621 L7.86206897,23.5862069"
                                id="Shape"
                            />
                            <path
                                d="M7.86206897,9.51724138 L7.86206897,14.4827586"
                                id="Shape"
                            />
                            <path
                                d="M7.86206897,0.413793103 L7.86206897,3.72413793"
                                id="Shape"
                            />
                            <rect
                                id="Rectangle-path"
                                x="0.413793103"
                                y="14.4827586"
                                width="14.8965517"
                                height="5.79310345"
                            />
                            <rect
                                id="Rectangle-path"
                                x="3.72413793"
                                y="3.72413793"
                                width="8.27586207"
                                height="5.79310345"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for aligning selected lights to the horizontal center.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered align center button.
 */
const AlignCenterButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default AlignCenterButton;
